const useAppStore = defineStore(
  'app',
  {
    state: () => ({
      title: import.meta.env.VITE_APP_TITLE,
      // 菜单折叠状态
      isCollapsed: false,
      // 是否为移动端（显示）
      isMobile: false,
      breakpoint: 768, // 默认小屏幕断点
      mobileToRoute:{}
    }),
    actions: {
      // 菜单折叠状态变更
      toggleCollapsed(){
        this.isCollapsed = !this.isCollapsed;
      },
      setIsMobile(flag){
        this.isMobile = flag;
      },
      setMobileRoute(route){
        this.mobileToRoute = route;
      }
    },
    getters: {
      getIsMobile: (state) => state.isMobile,
      getMobileRoute: state => state.mobileToRoute,
    }
  })
export default useAppStore